interface SliderInputProps {
  label: string
  description: string
  value: number
  onChange: (value: number) => void
  min: number
  max: number
  step: number
  unit: string
  format?: (value: number) => string
  defaultValue: number
  compact?: boolean
}

interface TextInputProps {
  label: string
  description: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  type?: string
  compact?: boolean
}

const inputClass = (compact?: boolean) =>
  compact
    ? 'field-input'
    : 'w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'

export function ProctoringTextInput({
  label,
  description,
  value,
  onChange,
  placeholder,
  type = 'text',
  compact,
}: TextInputProps) {
  return (
    <div>
      <label className="text-sm text-gray-300">{label}</label>
      <p className="text-xs text-gray-500 mb-2">{description}</p>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={inputClass(compact)}
      />
    </div>
  )
}

export function ProctoringSliderInput({
  label,
  description,
  value,
  onChange,
  min,
  max,
  step,
  unit,
  format,
  defaultValue,
  compact,
}: SliderInputProps) {
  const displayValue = format ? format(value) : `${value}${unit}`
  const isDefault = value === defaultValue
  const valueClass = compact
    ? isDefault
      ? 'text-gray-400'
      : 'text-primary-300'
    : isDefault
      ? 'text-gray-400'
      : 'text-blue-400'

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <label className="text-sm text-gray-300">{label}</label>
        <span className={`text-sm font-mono ${valueClass}`}>{displayValue}</span>
      </div>
      <p className="text-xs text-gray-500 mb-2">{description}</p>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className={`w-full h-2 rounded-lg appearance-none cursor-pointer ${
          compact ? 'bg-black/20 accent-primary-500' : 'bg-gray-700 accent-blue-500'
        }`}
      />
      <div className="flex justify-between text-xs text-gray-500 mt-0.5">
        <span>{format ? format(min) : `${min}${unit}`}</span>
        <span>{format ? format(max) : `${max}${unit}`}</span>
      </div>
    </div>
  )
}
